// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3aWTY","bigColWidth":"Table_bigColWidth__33rv2","biggerColWidth":"Table_biggerColWidth__ULVRA","row":"Table_row__14kbK","col":"Table_col__3Np6Q"};